<template>
  <div class="subscribe">
    <list-block>
      <div class="add">
        <el-select
          v-model="user"
          filterable
          remote
          reserve-keyword
          placeholder="请输入飞书账号"
          :remote-method="remoteMethod"
          :loading="loadingGetUser"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.name"
            :value="item"
          />
        </el-select>
        <el-button
          type="primary"
          :loading="loadingSubmit"
          @click="handleSubmit"
        >
          添加
        </el-button>
      </div>
      <div class="tips">
        tips: 每日11点通知
      </div>
      <div class="table-sty">
        <el-table
          :data="list"
          height="250"
          border
          style="width: 100%"
          :loading="loading"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50"
          />
          <el-table-column
            prop="unifyName"
            label="姓名"
          />
          <el-table-column
            prop="mobile"
            label="手机号码"
          />
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </list-block>
  </div>
</template>
<script>
import ListBlock from '@/components/ListBlock/index.vue';
import {
  popRuleManagementPage, fetchSubscribeDataPage, upsertSubscribeData, unifyUserIdentityAuthInfo,
} from '@/api/userControl';
import { USER_LIST_TABLE } from '../constant';

export default {
  name: 'Subscribe',
  components: {
    ListBlock,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: null,
    },

  },
  data() {
    return {
      id: null,
      pagination: {
        total: 0,
        pageSize: 20,
        currentPage: 1,
      },
      loading: false,
      list: [],
      USER_LIST_TABLE,
      options: [],
      loadingGetUser: false,
      user: '',
      loadingSubmit: false,
    };
  },
  watch: {
    pagination() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleDelete(row) {
      this.$confirm('你确定要删除该成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const arr = JSON.parse(JSON.stringify(this.list));
        const result = arr.filter((item) => item.unifyId !== row.unifyId);
        this.submitData(result);
      });
    },
    // eslint-disable-next-line consistent-return
    handleSubmit() {
      if (!this.user) {
        this.$message.warning('飞书账号不能为空！');
        return false;
      }

      if (this.list.filter((item) => item.unifyId === this.user.userId).length > 0) {
        this.$message.warning('该成员已存在！');
        return false;
      }
      const arr = JSON.parse(JSON.stringify(this.list));
      arr.unshift({ unifyId: this.user.userId, unifyName: this.user.realName, mobile: this.user.mobile });
      this.submitData(arr);
    },
    async submitData(arr) {
      try {
        this.loadingSubmit = true;
        const data = {
          ruleId: this.current.id,
          subscribers: arr,
        };
        await upsertSubscribeData(data);
        this.$message.success('保存成功');
        this.fetchData();
      } finally {
        this.user = '';
        this.loadingSubmit = false;
      }
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.options = [];
        this.loadingGetUser = true;
        const params = {};
        const data = {
          loginType: 'MOBILE',
          identifier: query,
          userIdentity: 'TENANT',
        };
        try {
          const { user, userIdentity } = await unifyUserIdentityAuthInfo(data, params);
          this.options = [
            {
              ...user,
              name: `${user.realName}(${user.mobile})`,
              originalUserId: userIdentity.originalUserId,
            },
          ];
        } finally {
          this.loadingGetUser = false;
        }
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const data = { ruleId: this.current.id };
        const params = {
          page: this.pagination.currentPage,
          size: this.pagination.pageSize,
        };
        const resp = await fetchSubscribeDataPage(data, params);
        this.pagination.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
    async fetchDetailsData() {
      try {
        const data = { id: this.id };
        const params = {
          page: 1,
          size: 10,
        };
        const resp = await popRuleManagementPage(data, params);
        this.details = resp.records?.[0];
      } finally {
        //
      }
    },
  },
};
</script>
  <style scoped lang="scss">
.subscribe{
  .table-sty{
    max-height: 300px;
  }
  .add{
      margin-top: -10px;
      .el-button{
          margin-left: 20px;
      }
  }
  .tips{
      font-size: 13px;
      color: #1e3cbb;
      margin: 10px 0;
  }
}
</style>
<style lang="scss">
.subscribe .table-sty{
  .el-table{
    max-height: 285px;
    overflow-y: auto;
  }
}
</style>
